import { CartItem,Product } from "data/types";

type ProductCoupon = {
  id?: number;
  code?: string;
  name?: string;
  value?: string | number;
  type?: string;
  scope?: "products" | "shipping";
} | null;

export function generateCartItem(
  item: Product,
  attributes: { [key: string]: string },
  coupon: ProductCoupon = null
): CartItem {
  const {
    id,
    name,
    slug,
    image,
    price,
    sale_price,
    parent_id,
    stock_quantity,
    pivot,
    limit_store,
    store_without_stock,
    in_promotion,
    counts_for_free_shipping,
  } = item;
  return {
    // id: Object.keys(attributes).length
    //   ? `${id}.${Object.values (attributes).join ('.')}`
    //   : id,
    name,
    slug,
    image,
    limit_store,
    stock_quantity,
    price: sale_price ? sale_price : price,
    attributes,
    id,
    parent_id: parent_id || id,
    pivot_parent_id: pivot?.parent_id,
    maxCartAmount: Boolean(limit_store)
      ? 1
      : !Boolean(store_without_stock)
      ? Number(stock_quantity)
      : undefined,
    coupon_id: coupon?.id ?? null,
    coupon_metadata: coupon
      ? {
          id: coupon.id,
          code: coupon.code,
          name: coupon.name,
          value: coupon.value,
          type: coupon.type,
          scope: coupon.scope,
        }
      : null,
    in_promotion: Boolean(in_promotion),
    counts_for_free_shipping,
  };
}
